// @flow
import React from 'react';
import { Button } from 'semantic-ui-react';

import * as css from './UncompletedOrder.module.css';
import { Footer, WarningCard } from 'components/';
import Header from 'views/Header';

type Props = {
  onCompleteSubscription: () => {},
};

const UncompletedOrder = ({ onCompleteSubscription }: Props) => {
  return (
    <>
      <Header isComviq={true} />
      <WarningCard
        title="Installationen \navbröts"
        text="Din senaste installation tycks ha blivit avbruten. Slutför installationen av ditt abonnemang här nedan."
      />
      <div className={css.footerContainer}>
        <Footer isComviq={true} isScrolled={false}>
          <Button primary fluid onClick={onCompleteSubscription} id="completeSubscription">
            {'Slutför installation'}
          </Button>
        </Footer>
      </div>
    </>
  );
};

export default React.memo(UncompletedOrder);
